export default __webpack_public_path__ + "static/media/musicblob.9f7547b1.svg";